export default "__VITE_ASSET__Cks0c8GI__"